import type { FaireProductEntity } from "../../entity_types/product";

export const p_2a5pnq4qgj: FaireProductEntity = {
  token: "p_2a5pnq4qgj",
  type: "product",
  name: "Aura Collection 3.7 oz Bath Salts",
  brandToken: "b_gffqu8d96t",
  brandName: "Lorabees",
  imageUrl:
    "https://cdn.faire.com/fastly/8dd546caf40715409a30407a553929f717879933c3ab0f7dc72fdcb313dbaf2f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/71c60ac6a6bba9ecfc8288fa1daa2e87e6e36fda0144ed95374fede5cf94c31c.jpeg",
    "https://cdn.faire.com/fastly/d4333029a7207db3bcfe22797e8941928b3d1927652d8ee7d9ce636656c1c709.jpeg",
    "https://cdn.faire.com/fastly/86fcdb080f0566c193ba5f529ab2816b7808f99ffb84d6bd85e79bf14a90babf.jpeg",
    "https://cdn.faire.com/fastly/923386c47c4212fcb3f22b2885f8a33797dfa05773c486177d63e372b691ddc0.jpeg",
    "https://cdn.faire.com/fastly/8a753921026c1602e20ef2be7df88bb953cdf56f93542563f2c0671cf2bd7137.jpeg",
    "https://cdn.faire.com/fastly/40e8894ff4ff2f777bff65466b2a4c67ff1911aec692625a0d24677a6f374a5b.jpeg",
    "https://cdn.faire.com/fastly/1e27c7be0dbde1b2f7042f2b8d996985c4787a5d6e37d1b1771cf7947ad7a0b4.jpeg",
    "https://cdn.faire.com/fastly/2f181e45143d646c9d00c460b648a75b5ab8ec9aeb474138dd580d8728c8732f.jpeg",
  ],
  priceDollars: 6.75,
  description:
    "These match our Aura Collection and are simple and luxurious. They are crafted with Epsom Salt, Detoxifying Dead Sea Salt, Pink Himalayan Salt, and high end fragrance and Essential Oil.  We DO NOT put any drain-clogging clays or nuisance dried botanicals that get stuck to your skin and tub. Our bath salt philosophy is simple, calming, and softening. Net wt. 3.7 oz\nChoose from 9 scents from our Aura Collection\n\n*Our Bath Salts are measured and weighed, settling may occur in the tubes. \n\n*Vessels/Packaging/Ingredients may vary due to sourcing availability.",
  tags: [],
  msrpDollars: 13.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:25.823Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
